import type {
  AgentCodeTestConfigChange,
  AgentCodeTestConfigFields,
  AgentTestOperation,
} from '../../../../types';
import { isAgentCodeTestCreateChange } from '../../../../types';

export const formatCodeTestConfigFieldsSummary = (
  fields: AgentCodeTestConfigFields,
): string => {
  const parts: string[] = [];

  if (fields.severity)
    parts.push(
      `severity: ${fields.severity.current ?? 'none'} \u2192 ${
        fields.severity.new ?? 'none'
      }`,
    );
  if (fields.description) parts.push('description');
  if (fields.tags)
    parts.push(
      `tags: ${fields.tags.current.length} \u2192 ${fields.tags.new.length}`,
    );
  if (fields.owners)
    parts.push(
      `owners: ${fields.owners.current.length} \u2192 ${fields.owners.new.length}`,
    );
  if (fields.params) {
    const paramKeys = Object.keys(fields.params);
    if (paramKeys.length) parts.push(`params: ${paramKeys.join(', ')}`);
  }

  return parts.join(', ') || 'no changes';
};

export const formatCodeTestChangeSummary = (
  change: AgentCodeTestConfigChange,
  operation: AgentTestOperation,
): string => {
  if (operation === 'delete') {
    return 'delete test';
  }
  if (isAgentCodeTestCreateChange(change)) {
    const configSummary = formatCodeTestConfigFieldsSummary(change);
    return `Create ${change.testType} test — ${configSummary}`;
  }
  return formatCodeTestConfigFieldsSummary(change);
};

export const formatCodeTestChangeLabel = (
  change: AgentCodeTestConfigChange,
): string => {
  if (isAgentCodeTestCreateChange(change)) {
    return change.column
      ? `${change.resourceName}.${change.column}`
      : change.resourceName;
  }
  return change.testName || change.testId;
};
